import React, { Fragment, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import * as CPN from "antd";
import * as Func from "helpers/functions";
import { PATHS } from 'constants/Define';
import { Link } from 'react-router-dom';
import Span from 'containers/backend/common/component/Span';
import Dropdown from 'containers/backend/common/component/Dropdown';
import Modal from 'containers/backend/common/component/Modal';


const EditComponent = (props) => {
    //! State
    const {t} = useTranslation();
    const {permissionActions, deleteAppUIConfig, item} = props;
    //! Function
    const removeItem = () => {
        deleteAppUIConfig && deleteAppUIConfig(item.id)
    }

    const onRemove = () => {
        const { confirm } = Modal;
        confirm({
            title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.app.title`)),
            content: item.description,
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: removeItem,
        });
    }
    //! Effect

    //! Render
  return (
    <Fragment>
        <Dropdown overlay={
            <CPN.Menu className="action-menu">
                {
                    props.permissionActions && props.permissionActions.allowUpdate &&
                    <CPN.Menu.Item>
                        <Link to={Func.getPathWithParams(PATHS.APP.DETAIL.path, { id: props.item.id })} className={`mr-2`}>
                            <CPN.Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                        </Link>
                    </CPN.Menu.Item>
                }

                {
                    props.permissionActions && props.permissionActions.allowDelete &&
                    <CPN.Menu.Item onClick={onRemove}><CPN.Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</CPN.Menu.Item>
                }
            </CPN.Menu>
        }>
            <CPN.Icon type="more" className="fs20 cursorPointer" />
        </Dropdown>
    </Fragment>
  )
}

export default EditComponent